import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Badge } from 'rsuite';

// redux
import { getCampaignElementOptionLabel } from '../../redux/modules/campaigns';
// components
import EditActions from './EditActions';
// styles
import styles from './PromptLabelContainer.module.less';

const PromptLabelContainer = ({
  elementLabel = '',
  crakId = '',
  campaignElementId = '',
  hideEditActions = false,
  ...rest
}) => {
  return (
    <div className={styles.vpPromptLabelContainer}>
      <div className={styles.vpPromptBadgeContainer}><Badge className={styles.vpPromptBadgeLabel} content={elementLabel} /></div>
      {!hideEditActions &&
        <EditActions {...rest} />
      }
    </div>
  )
};

PromptLabelContainer.propTypes = {
  elementLabel: PropTypes.string,
  crakId: PropTypes.string,
  campaignElementId: PropTypes.string,
  hideEditActions: PropTypes.bool,
};

const mapStateToProps = (state, ownProps) => ({
  elementLabel: getCampaignElementOptionLabel(state, { crakId: ownProps?.crakId, campaignElementId: ownProps?.campaignElementId })
});

export default connect(mapStateToProps)(PromptLabelContainer);



// WEBPACK FOOTER //
// ./src/components/CampaignEdit/PromptLabelContainer.jsx